import dayjs from 'dayjs';
import { renderToString } from 'react-dom/server';

export function GenerateTicketExample(paperSaving = false) {
  const s = paperSaving;
  const html = <div style={{ pageBreakAfter: "always" }}>
    <div style={{
      fontFamily: "sans-serif",
      marginRight: s ? "10px" : "30px",
      marginLeft: s ? "5px" : "10px"
    }}>
      {!s && <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#c4c4c4",
          color: "#000",
          borderRadius: "15px",
          width: "50px",
          height: "50px",
          marginRight: "10px",
          fontSize: '30px',
          marginTop: '10px',
          marginBottom: '20px'
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" className="iconify iconify--mdi" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 18H6v-4h6m9 0v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6m0-10H4v2h16z"></path></svg>
        </div>
      </div>}
      <div style={{ fontSize: s ? '14px' : '20px' }}>
        <strong>Negocio de ejemplo</strong>
      </div>
      <div style={{ fontSize: s ? '11px' : '15px' }}>
        <div>
          <strong>Av. de la Constitución, 1</strong>
        </div>
        <div>
          <strong>CIF: 123456789</strong>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginTop: s ? '4px' : '10px' }}>
          <strong>Fecha: 12/12/2021</strong>
          <strong>Tiket: 1</strong>
        </div>
        <div style={{
          marginTop: s ? "5px" : "20px",
          marginBottom: s ? "5px" : "20px",
        }}>
          <div style={{
            marginBottom: s ? "3px" : "10px",
            marginTop: s ? "3px" : "10px",
          }}>
            <strong>Productos</strong>
          </div>
          <table>
            <tr>
              <th>Cant.</th>
              <th>Producto</th>
              <th>Precio</th>
              <th>Total</th>
            </tr>
            <tr>
              <td>1</td>
              <td>COCACOLA</td>
              <td>2.00€</td>
              <td>2.00€</td>
            </tr>

          </table>
          <div style={{
            textAlign: "right",
            marginTop: s ? "3px" : "10px",
            marginBottom: s ? "3px" : "10px",
            fontSize: s ? "9px" : "10px"
          }}>
            <strong>Subtotal: 2.00€</strong>
          </div>
          <div style={{
            marginTop: s ? "3px" : "10px",
            marginBottom: s ? "3px" : "10px",
          }}>
            <strong>Impuestos Aplicados</strong>
          </div>
          <div>

            <table>
              <tr>
                <th>Concepto</th>
                <th>Cantidad</th>
              </tr>
              <tr>
                <td>IVA 10%</td>
                <td>0.20€</td>
              </tr>
            </table>
            <div style={{
              textAlign: "right",
              fontSize: s ? "9px" : "10px",
              marginTop: s ? "3px" : "10px",
            }}>
              <strong>Subtotal Impuestos: 0.20€</strong>
            </div>
          </div>
          <div style={{
            textAlign: "center",
            fontSize: s ? "14px" : "20px",
            marginTop: s ? "5px" : "20px",
          }}>
            <div><strong>TOTAL</strong></div>
            <div style={{
              fontSize: s ? "18px" : "25px"
            }}><strong>2.00€</strong></div>
          </div>
        </div>
        <div style={{
          marginTop: s ? "5px" : "20px",
          marginBottom: s ? "20px" : "60px",
          textAlign: "center"
        }}>
          <p>Gracias por su visita</p>
        </div>
      </div>
    </div>

  </div>;

  //return html as string
  return renderToString(html);
}


export function GenerateTicket(ticket, paperSaving = false) {

  const s = paperSaving;

  // El backend sirve el listado de tickets con carga selectiva (sin tienda,
  // mods ni impuestos) y el detalle completo en GET /tickets/{id}. Esta función
  // no puede asumir que las relaciones vienen cargadas o revienta al pintar.
  const shop = ticket.shop || {};
  const lines = ticket.lines || [];
  const pagos = ticket.pagos || [];

  //calculate tax
  let tax = {}

  //total tax
  let total_tax = 0

  lines.forEach((line) => {
    const price = Number(line.custom_price) || 0;
    const quantity = Number(line.quantity) || 0;
    // el snapshot del IVA del ticket manda sobre el valor actual del producto
    const rate = line.tax_rate ?? line.products?.tax?.value ?? 0;
    const name = line.products?.tax?.name ?? 'IVA';
    let no_tax_price = (price * quantity) / (1 + (rate / 100));
    let tax_price = ((price * quantity) - no_tax_price);
    total_tax += tax_price;
    tax[name] = (tax[name] || 0) + tax_price;
  })

  // Estimar altura del ticket para añadir margen inferior dinámico
  // y evitar que se corte en impresoras térmicas (alto de página no fijo)
  const lineHeight = s ? 14 : 20; // px por fila aprox
  const modHeight = s ? 10 : 14;
  let estimatedRows = lines.length; // productos
  lines.forEach(l => { estimatedRows += (l.mods?.length || 0); }); // mods
  estimatedRows += Object.keys(tax).length; // filas de impuestos
  estimatedRows += (pagos.length || 1); // filas de pagos (mín 1)
  estimatedRows += 8; // cabecera, subtotal, total, separadores, footer
  const extraMargin = Math.max(0, (estimatedRows - 12) * lineHeight); // 12 filas base caben sin extra
  const dynamicMarginBottom = s ? 20 + extraMargin : 60 + extraMargin;


  const html = <div style={{ pageBreakAfter: "always" }}>
    <div style={{
      fontFamily: "sans-serif",
      marginRight: s ? "10px" : "30px",
      marginLeft: s ? "5px" : "10px"
    }}>
      {!s && <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#c4c4c4",
          color: "#000",
          borderRadius: "15px",
          width: "50px",
          height: "50px",
          marginRight: "10px",
          fontSize: '30px',
          marginTop: '10px',
          marginBottom: '20px'
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" className="iconify iconify--mdi" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 18H6v-4h6m9 0v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6m0-10H4v2h16z"></path></svg>
        </div>
      </div>}
      <div style={{ fontSize: s ? '14px' : '20px' }}>
        <strong>{shop.fiscal_name}</strong>
      </div>
      <div style={{ fontSize: s ? '11px' : '15px' }}>
        <div>
          <strong>{shop.fiscal_address}</strong>
        </div>
        <div>
          <strong>CIF: {shop.fiscal_id}</strong>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginTop: s ? '4px' : '10px' }}>
          <strong>{dayjs(ticket.created_at).format('DD-MM-YYYY HH:mm')}</strong>
          <strong> #{ticket.exercise_id + '/' + ticket.reference}</strong>
        </div>
        <div style={{
          marginTop: s ? "5px" : "20px",
          marginBottom: s ? "5px" : "20px",
        }}>
          <div style={{
            marginBottom: s ? "3px" : "10px",
            marginTop: s ? "3px" : "10px",
          }}>
            <strong>Productos</strong>
          </div>
          <table style={{
            fontSize: s ? "9px" : "10px",
            fontWeight: 600
          }}>
            <tr>
              <th>Cant.</th>
              <th>Producto</th>
              <th>Precio</th>
              <th>Total</th>
            </tr>
            {lines.map((product, index) => {
              if (!product.mods) {
                product.mods = []
              }
              return <>
                <tr key={index} style={{
                  fontWeight: 600
                }}>
                  <td>{product.quantity}</td>
                  <td>{product.products?.name}</td>
                  <td>{Number(product.custom_price).toFixed(2)}€</td>
                  <td>{(Number(product.custom_price) * product.quantity).toFixed(2)}€</td>
                </tr>
                {product?.mods?.length > 0 && <>
                  {product?.mods?.map((mod, index) => <tr key={index} style={{
                    fontSize: s ? "8px" : "10px",
                    fontWeight: 600
                  }}>
                    <td></td>
                    <td>+ {mod.mod.defaultEnabled ? 'Sin ' : 'Con '}{mod.mod.name} {mod.mod.price > 0 ? '(' + Number(mod?.mod?.price).toFixed(2) + '€)' : ''}</td>
                    <td></td>
                    <td></td>
                  </tr>)}
                </>}
              </>
            })}

          </table>
          <div style={{
            textAlign: "right",
            marginTop: s ? "3px" : "10px",
            marginBottom: s ? "3px" : "10px",
            fontSize: s ? "9px" : "10px"
          }}>
            <strong>Subtotal: {Number(ticket.total).toFixed(2)}€</strong>
          </div>
          <div style={{
            marginTop: s ? "3px" : "10px",
            marginBottom: s ? "3px" : "10px",
          }}>
            <strong>Impuestos Aplicados</strong>
          </div>
          <div>

            <table style={{
              fontSize: s ? "9px" : "10px",
              fontWeight: 600
            }}>
              <tr>
                <th>Concepto</th>
                <th>Cantidad</th>
              </tr>
              {
                Object.keys(tax).map((key, index) => {
                  return <tr key={index}>
                    <td>{key}</td>
                    <td>{tax[key].toFixed(2)}€</td>
                  </tr>
                })
              }

            </table>
            <div style={{
              textAlign: "right",
              fontSize: s ? "9px" : "10px",
              marginTop: s ? "3px" : "10px",
            }}>
              <strong>Subtotal Impuestos: {total_tax.toFixed(2)}€</strong>
            </div>
          </div>
          <div style={{
            textAlign: "center",
            fontSize: s ? "14px" : "20px",
            marginTop: s ? "5px" : "20px",
          }}>
            <div><strong>TOTAL</strong></div>
            <div style={{
              fontSize: s ? "20px" : "30px"
            }}><strong>{Number(ticket.total).toFixed(2)}€</strong></div>
            <div>

            </div>

          </div>
          <div style={{
            marginTop: s ? "3px" : "10px",
            marginBottom: s ? "3px" : "10px",
          }}>
            <strong>Pagos</strong>
          </div>
          <table style={{
            fontSize: s ? "9px" : "10px",
            fontWeight: 600
          }}>
            <tr>
              <th>Tipo de pago</th>
              <th>Cantidad</th>
            </tr>
            {
              ticket.pagos?.length > 0 ? pagos.map((key, index) => {
                return <tr key={index}>
                  <td>{key.tipopago?.name}</td>
                  <td>{Number(key.importe).toFixed(2)}€</td>
                </tr>
              }) : (
                <tr>
                  <td colSpan={2}>Sin pagos registrados</td>
                </tr>
              )
            }

          </table>
        </div>
        <div style={{
          marginTop: s ? "5px" : "20px",
          marginBottom: dynamicMarginBottom,
          textAlign: "center"
        }}>
          <p>Gracias por su visita</p>
        </div>
      </div>
    </div>

  </div>;

  //return html as string
  return renderToString(html);
}

/**
 * Acta de cierre de caja.
 *
 * `arqueo` es el snapshot del backend (POST /registers/{id}/close devuelve
 * snapshot + register): el desglose por forma de pago y los importes del
 * arqueo. La tienda llega aparte porque el cierre no la carga en la relación.
 */
export function GenerateRegisterTicket(arqueo, shop = {}, paperSaving = false) {
  const s = paperSaving;

  const payments = arqueo?.payments || [];
  const money = (value) => Number(value || 0).toFixed(2) + '€';

  const collected = payments.reduce(
    (total, payment) => total + (Number(payment.total) || 0),
    0,
  );

  const difference = Number(arqueo?.cash_difference || 0);
  const differenceText =
    Math.abs(difference) < 0.005
      ? 'La caja cuadra'
      : difference < 0
        ? 'Faltan ' + Math.abs(difference).toFixed(2) + '€'
        : 'Sobran ' + difference.toFixed(2) + '€';

  // Estimar altura para margen dinámico (filas de pagos + 6 filas arqueo + notas + cabecera)
  const lineHeight = s ? 14 : 20;
  let estimatedRowsReg = (payments.length || 1) + 6 + (arqueo?.closed_notes ? 1 : 0) + 8;
  const extraMarginReg = Math.max(0, (estimatedRowsReg - 12) * lineHeight);
  const dynamicMarginBottomReg = s ? 20 + extraMarginReg : 60 + extraMarginReg;

  const html = <div style={{ pageBreakAfter: "always" }}>
    <div style={{
      fontFamily: "sans-serif",
      marginRight: s ? "10px" : "30px",
      marginLeft: s ? "5px" : "10px"
    }}>
      {!s && <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#c4c4c4",
          color: "#000",
          borderRadius: "15px",
          width: "50px",
          height: "50px",
          marginRight: "10px",
          fontSize: '30px',
          marginTop: '10px',
          marginBottom: '20px'
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" className="iconify iconify--mdi" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M2 17h20v4H2zM6.25 7H9V6H6V3h8v3h-3v1h6.8c1 0 2 1 2.2 2l.5 7h-17l.55-7c0-1 1-2 2.2-2M13 9v2h5V9zM6 9v1h2V9zm3 0v1h2V9zm-3 2v1h2v-1zm3 0v1h2v-1zm-3 2v1h2v-1zm3 0v1h2v-1zM7 4v1h6V4z"></path></svg>
        </div>
      </div>}
      <div style={{ fontSize: s ? '14px' : '20px' }}>
        <strong>Cierre de caja</strong>
      </div>
      <div style={{ fontSize: s ? '14px' : '20px' }}>
        <strong>{shop.fiscal_name}</strong>
      </div>
      <div style={{ fontSize: s ? '11px' : '15px' }}>
        <div>
          <strong>{shop.fiscal_address}</strong>
        </div>
        <div>
          <strong>CIF: {shop.fiscal_id}</strong>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginTop: s ? '4px' : '10px' }}>
          <strong>{dayjs(arqueo?.closed_at).format('DD-MM-YYYY HH:mm')}</strong>
          <strong> #{arqueo?.register_id}</strong>
        </div>
        <div style={{
          marginTop: s ? "5px" : "20px",
          marginBottom: s ? "5px" : "20px",
        }}>
          <div style={{
            marginBottom: s ? "3px" : "10px",
            marginTop: s ? "3px" : "10px",
          }}>
            <strong>Ventas del turno</strong>
          </div>
          <table style={{
            fontSize: s ? "9px" : "10px",
            fontWeight: 600

          }}>
            <tr>
              <th>Tickets</th>
              <th style={{ textAlign: "right" }}>Total</th>
            </tr>
            <tr>
              <td>{arqueo?.tickets_count ?? 0}</td>
              <td style={{ textAlign: "right" }}>{money(arqueo?.total_sales)}</td>
            </tr>
          </table>
          <div style={{
            marginTop: s ? "3px" : "10px",
            marginBottom: s ? "3px" : "10px",
          }}>
            <strong>Cobros por forma de pago</strong>
          </div>
          <table style={{
            fontSize: s ? "9px" : "10px",
            fontWeight: 600
          }}>
            <tr>
              <th>Pago</th>
              <th style={{ textAlign: "right" }}>Cobros</th>
              <th style={{ textAlign: "right" }}>Total</th>
            </tr>
            {
              payments.length === 0
                ? <tr>
                  <td colSpan={3}>Sin cobros registrados</td>
                </tr>
                : payments.map((payment) => <tr key={payment.tipopago_id}>
                  <td>{payment.name}</td>
                  <td style={{ textAlign: "right" }}>{payment.payment_count}</td>
                  <td style={{ textAlign: "right" }}>{money(payment.total)}</td>
                </tr>)
            }

          </table>
          <div style={{
            textAlign: "right",
            marginTop: s ? "3px" : "10px",
            marginBottom: s ? "3px" : "10px",
            fontSize: s ? "9px" : "10px"
          }}>
            <strong>Total cobrado: {money(collected)}</strong>
          </div>
          <div style={{
            marginTop: s ? "3px" : "10px",
            marginBottom: s ? "3px" : "10px",
          }}>
            <strong>Arqueo de caja</strong>
          </div>
          <table style={{
            fontSize: s ? "9px" : "10px",
            fontWeight: 600
          }}>
            <tr>
              <td>Fondo de apertura</td>
              <td style={{ textAlign: "right" }}>{money(arqueo?.opening_amount)}</td>
            </tr>
            <tr>
              <td>Cobrado en efectivo</td>
              <td style={{ textAlign: "right" }}>{money(arqueo?.cash_collected)}</td>
            </tr>
            <tr>
              <td><strong>Debería haber</strong></td>
              <td style={{ textAlign: "right" }}><strong>{money(arqueo?.expected_cash)}</strong></td>
            </tr>
            <tr>
              <td>Efectivo contado</td>
              <td style={{ textAlign: "right" }}>{money(arqueo?.counted_cash)}</td>
            </tr>
            <tr>
              <td><strong>Diferencia</strong></td>
              <td style={{ textAlign: "right" }}><strong>{differenceText}</strong></td>
            </tr>
          </table>
          {arqueo?.closed_notes && (
            <div style={{
              marginTop: s ? "3px" : "10px",
              fontSize: s ? "9px" : "10px",
            }}>
              <strong>Observaciones: {arqueo.closed_notes}</strong>
            </div>
          )}

        </div>
        <div style={{
          marginTop: s ? "5px" : "20px",
          marginBottom: dynamicMarginBottomReg,
          textAlign: "center"
        }}>
          <p>Gracias por usar nuestro TPV</p>
        </div>
      </div>
    </div>

  </div>;

  //return html as string
  return renderToString(html);
}

export function GenerateComanda(comanda, paperSaving = false) {
  const s = paperSaving;

  // Estimar altura para margen dinámico (productos + mods + cabecera)
  const lineHeight = s ? 14 : 20;
  const modHeight = s ? 10 : 14;
  let estimatedRowsCom = (comanda.cart?.length || 0);
  comanda.cart?.forEach(p => { estimatedRowsCom += (p.custom_mods?.length || 0); });
  estimatedRowsCom += 6; // cabecera, separadores, footer
  const extraMarginCom = Math.max(0, (estimatedRowsCom - 10) * lineHeight);
  const dynamicMarginBottomCom = s ? 20 + extraMarginCom : 60 + extraMarginCom;

  const html = <div style={{ pageBreakAfter: "always" }}>
    <div style={{
      fontFamily: "sans-serif",
      marginRight: s ? "10px" : "30px",
      marginLeft: s ? "5px" : "10px"
    }}>

      <div style={{ fontSize: s ? '11px' : '15px' }}>
        <div>
          <strong>Comanda</strong>
        </div>
        <div>
          {comanda.name}
        </div>
        <div>
          {comanda.notes}
        </div>

        <div style={{
          marginTop: s ? "5px" : "20px",
          marginBottom: s ? "5px" : "20px",
        }}>
          <div style={{
            marginBottom: s ? "3px" : "10px",
            marginTop: s ? "3px" : "10px",
          }}>
            <strong>Productos</strong>
          </div>
          <table style={{
            fontSize: s ? "9px" : "10px",
            fontWeight: 600
          }}>
            <tr>
              <th>Cant.</th>
              <th>Producto</th>
            </tr>
            {comanda.cart.map((product, index) => <>
              <tr key={index} style={{
                fontWeight: 600
              }}>
                <td>{product.quantity}</td>
                <td>{product.name}</td>
              </tr>
              {product?.custom_mods?.length > 0 && <>
                {product?.custom_mods?.map((mod, index) => <tr key={index} style={{
                  fontSize: s ? "8px" : "10px",
                  fontWeight: 600
                }}>
                  <td></td>
                  <td>+ {mod.defaultEnabled ? 'Sin ' : 'Con '}{mod.name} {mod.price > 0 ? '(' + Number(mod?.price).toFixed(2) + '€)' : ''}</td>
                </tr>)}
              </>}
            </>)}

          </table>
        </div>
        <div style={{
          marginTop: s ? "5px" : "20px",
          marginBottom: dynamicMarginBottomCom,
          textAlign: "center"
        }}>
          <p>Gracias</p>
        </div>
      </div>
    </div>

  </div>;

  //return html as string
  return renderToString(html);
}